import { OutGoingCallOnsecretaryActionstate } from "../interfaces/callDirectOnSeretary"
import { Types } from "../types"
import { OutGoingCallOnsecretaryActions } from "../types/outGoingCallOnSecretary/actionType"





const initialState: OutGoingCallOnsecretaryActionstate = {
    getOutGoingCallOnSecretaryPending: false,
    getOutGoingCallOnSecretarySuccess: false,
    getOutGoingCallOnSecretaryError:'',
    getOutGoingCallOnSecretaryResult: {},

    setOutGoingCallOnSecretaryPending: false,
    setOutGoingCallOnSecretarySuccess: false,
    setOutGoingCallOnSecretaryError:'',
    setOutGoingCallOnSecretaryResult: {}

}


const outGoingCallOnsecretaryReducer = (state = initialState, action: OutGoingCallOnsecretaryActions) => {
    switch (action.type) {
        case Types.GET_OUT_GOING_ON_SECRETARY_SETTINGS_REQUEST:
            return {
                ...state,
                getOutGoingCallOnSecretaryPending: true,
                getOutGoingCallOnSecretarySuccess: false,
                getOutGoingCallOnSecretaryError:'',
            }

        case Types.GET_OUT_GOING_ON_SECRETARY_SETTINGS_SUCCESS:
                        return {
                ...state,
                getOutGoingCallOnSecretaryPending: false,
                getOutGoingCallOnSecretarySuccess: true,
                getOutGoingCallOnSecretaryError:'',
                getOutGoingCallOnSecretaryResult: action?.payload?.params,
            }
        case Types.GET_OUT_GOING_ON_SECRETARY_SETTINGS_ERROR:
            return {
                ...state,
                getOutGoingCallOnSecretaryPending: false,
                getOutGoingCallOnSecretarySuccess: false,
                getOutGoingCallOnSecretaryError:action?.payload?.error,
            }
            //set

            case Types.SET_OUT_GOING_ON_SECRETARY_SETTINGS_REQUEST:
                return {
                    ...state,
                    setOutGoingCallOnSecretaryPending: true,
                    setOutGoingCallOnSecretarySuccess: false,
                    setOutGoingCallOnSecretaryError:'',
                }
    
            case Types.SET_OUT_GOING_ON_SECRETARY_SETTINGS_SUCCESS:
                return {
                    ...state,
                    setOutGoingCallOnSecretaryPending: false,
                    setOutGoingCallOnSecretarySuccess: true,
                    setOutGoingCallOnSecretaryError:'',
                    setOutGoingCallOnSecretaryResult: action?.payload,
                }
            case Types.SET_OUT_GOING_ON_SECRETARY_SETTINGS_ERROR:

                return {
                    ...state,
                    setOutGoingCallOnSecretaryPending: false,
                    setOutGoingCallOnSecretarySuccess: false,
                    setOutGoingCallOnSecretaryError:action?.payload?.error,
                }
                //reset
                case Types.RESET_OUT_GOING_ON_SECRETARY_SETTINGS:
                                 return {
                    ...state,    
                    getOutGoingCallOnSecretaryError:'',             
                    setOutGoingCallOnSecretaryError:'',
                    setOutGoingCallOnSecretarySuccess:false,
                    setOutGoingCallOnSecretaryResult:{}
                    
             
                
                }
           

     
        default:
            return {
                ...state,
            }
    }
}

export default outGoingCallOnsecretaryReducer